<template>
  <div>
    <nav class="navbar navbar-expand-md fixed-top sticky-navigation">
      <a class="navbar-brand" href="/">
        <img src="@/assets/images/replyninja_logo.svg" alt="reply ninja logo" />
      </a>
      <button
        class="navbar-toggler navbar-toggler-right border-0"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span data-feather="menu"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link class="nav-link page-scroll" to="/#features">Features</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/upgrade">Upgrade</router-link>
          </li>
          <li class="nav-item">
            <a onclick="$crisp.push(['do', 'chat:open'])" class="nav-link">Feedback</a>
          </li>
          <li class="nav-item btn-login">
            <router-link v-if="getCurrentUser" class="nav-link page-scroll" to="/account">Account</router-link>
            <div
              v-if="!getCurrentUser && !isAuthLoading"
              class="nav-link page-scroll"
              @click="googleAuth()"
            >Login</div>
            <div v-if="isAuthLoading" class="nav-link page-scroll">...</div>
          </li>
          <!-- <li class="nav-item">
            <a class="nav-link page-scroll" href="#pricing">Pricing</a>
          </li>-->
          <!-- <li class="nav-item">
            <a class="nav-link page-scroll" href="#faq">FAQ</a>
          </li>-->
        </ul>
      </div>
      <nav class="navigation" role="navigation">
        <div id="menuToggle">
          <input v-model="closeMobileMenu" type="checkbox" />
          <span></span>
          <span></span>
          <span></span>

          <ul id="menu">
            <router-link @click="closeMobileMenu" to="/#features">
              <li>Features</li>
            </router-link>
            <router-link @click="closeMobileMenu" to="/upgrade">
              <li>Upgrade</li>
            </router-link>
            <a @click="closeMobileMenu" class="cursor" onclick="$crisp.push(['do', 'chat:open'])">
              <li>Feedback</li>
            </a>
            <li @click="closeMobileMenu" class="menu-align p-0 cursor">
              <router-link v-if="getCurrentUser" to="/account" class="mobile-menu">Account</router-link>
              <div
                v-if="!getCurrentUser && !isAuthLoading"
                @click="googleAuth()"
                class="mobile-menu"
              >Login</div>
              <div v-if="isAuthLoading" class="mobile-menu">...</div>
            </li>
          </ul>
        </div>
      </nav>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase";

export default {
  data() {
    return {
      closeMobileMenu: false
    };
  },
  computed: {
    ...mapGetters(["getCurrentUser", "isAuthLoading"])
  },
  methods: {
    closeMobileMenu() {
      closeMobileMenu === true;
    },
    /* TODO: Fix issue with new user being able to signup through login
     */
    googleAuth() {
      const provider = new firebase.auth.GoogleAuthProvider();

      firebase
        .auth()
        .signInWithPopup(provider)
        .then(result => {
          this.$router.push({ name: "account" });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.cursor {
  cursor: pointer;
}

.menu-align {
  margin-top: 5px;
}
</style>